import type { ReactNode } from "react";
import { PanelToggle } from "@/shared/ui/primitives/PanelToggle";

export function FrameOpener({
  label,
  onClick,
  tour,
  children,
}: {
  label: string;
  onClick: () => void;
  tour?: string;
  children: ReactNode;
}) {
  return (
    <PanelToggle
      label={label}
      onClick={onClick}
      data-tour={tour}
      className="absolute top-[20px] right-[16px] z-[2]"
    >
      {children}
    </PanelToggle>
  );
}
